import { useState, useCallback, useEffect } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import UserEmailDisplay from '../../components/UserEmailDisplay/UserEmailDisplay';
import AppSnackbar from '../../components/AppSnackbar/AppSnackbar';
import { styles } from './UsuariosLogadosPage.styles';
import CadastroHeader from '../../components/CadastroHeader/CadastroHeader';
import { usePermissao } from '../../app/hooks/UsePermissao';
import { api } from '../../services/apiService';

const ROLES = [
  { id: 1, nome: 'Administrador' },
  { id: 2, nome: 'Supervisor' },
  { id: 3, nome: 'Operador' },
  { id: 4, nome: 'Visualizador' },
  { id: 5, nome: 'Auditor' },
];

function LoggedInUserCard({ nome, detalhe, onRemover }) {

  return (
    <Box sx={styles.userCard}>
      <Box sx={styles.statusRow}>
        <Box sx={styles.statusDot} aria-hidden />
        <Box sx={{ minWidth: 0, overflow: 'hidden', flex: 1 }}>
          <Typography component="div" sx={styles.userName} title={nome}>
            {nome}
          </Typography>
          <Typography component="div" sx={styles.userDetail}>
            {detalhe}
          </Typography>
        </Box>
      </Box>
          {onRemover && (
            <Button
                variant="contained"
                disableElevation
                sx={styles.removerBtn}
                onClick={onRemover}
              >
              Remover
            </Button>
          )}
    </Box>
  );
}

export default function UsuariosLogadosPage() {
    const { temPermissao } = usePermissao();
    const temAcesso = temPermissao("Operador.Remover");

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
      const [usuariosOnline, setUsuariosOnline] = useState([]);


  const fetchUsuariosLogados = useCallback(() => {
    api.usuariosLogados.getAll()
      .then(res => setUsuariosOnline(res.data))
      .catch(err => console.error('Erro ao buscar usuários logados:', err));
  }, []);

  useEffect(() => {
    fetchUsuariosLogados();
  }, [fetchUsuariosLogados]);


  const handleRemover = useCallback((id) => {
    api.usuariosLogados.putUsuarioLogado(id)
      .then(() => {
        setUsuariosOnline((prev) => prev.filter((u) => u.id !== id));
        setSnackbar({ open: true, message: 'Usuário removido com sucesso.', severity: 'success' });
      })
      .catch(() => {
        setSnackbar({ open: true, message: 'Erro ao remover usuário.', severity: 'error' });
      });
  }, []);

  return (
    <>
      <Box sx={styles.pageWrapper}>

        <Box component="main" sx={styles.mainContent}>
          <Paper elevation={0} sx={styles.card}>

           <CadastroHeader
              title="Usuários Logados"
              subtitle="Usuários logados no sistema"
            />

            <Box sx={styles.grid}>
              {ROLES.map((role) => (
                <Box key={role.id} sx={styles.column}>
                  <Box component="header" sx={styles.columnHeader}>
                    {role.nome}
                  </Box>
                  <Box sx={styles.columnBody}>
                  {usuariosOnline.filter(u => u.roleId === role.id).map(u => (
                    <LoggedInUserCard
                      key={u.id}
                      nome={u.email}
                      detalhe={u.linhaNome ? `Linha: ${u.linhaNome}` : 'Sem linha associada'}
                      {...(u.roleId === 3 && temAcesso && {
                        onRemover: () => handleRemover(u.id)
                      })}

                    />
                  ))}

                  </Box>
                </Box>
              ))}
            </Box>

          </Paper>
        </Box>
      </Box>

      <AppSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      />
    </>
  );
}
